module.exports = __webpack_public_path__ + "img/tele.a7a29a67.svg";